import { render, staticRenderFns } from "./SaCounter.vue?vue&type=template&id=052f605f&"
import script from "./SaCounter.vue?vue&type=script&lang=js&"
export * from "./SaCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports